<script lang="ts" setup>
import { useLayoutStore } from '@/stores/layout';
import { MenuItem } from '@/types';
import { useResizeObserver } from '@vueuse/core';
import { useTemplateRef } from 'vue';
defineEmits(['update']);
defineProps<{ visible: boolean; items: MenuItem[] }>();

const store = useLayoutStore();
const el = useTemplateRef('sidebar');

useResizeObserver(el, (entries) => {
    const entry = entries[0];
    const { height } = entry.contentRect;
    store.setSidebarHeight(height);
});
</script>
<template>
    <SimpleCard
        ref="sidebar"
        data-testid="sidenav"
        :class="[
            'fixed left-8 top-24 w-72 sidebar',
            { 'sidebar-inactive': !visible }
        ]"
    >
        <AppNavItem v-for="item in items" :key="item.key" :item="item" />
    </SimpleCard>
</template>
<style lang="scss" scoped>
.sidebar {
    height: calc(100vh - 9rem);
    transition:
        transform 0.2s,
        left 0.2s;
}
.sidebar-inactive {
    transform: translateX(-100%);
    left: 0;
}
.router-link-active {
    color: var(--p-blue-400);
}
</style>
